import PropTypes from 'prop-types';

const PricesColumn = ({ value }) => (
  <span style={{ width: '60px', textAlign: 'right', display: 'block' }}>
    {value ? parseFloat(value).toFixed(2) : 'Call'}
  </span>
);

PricesColumn.propTypes = {
  value: PropTypes.string
};

export default PricesColumn;
